/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn a daily calorie target into grams of protein, carbs and fat. Pick a split and the calculator does the math using 4 kcal per gram of protein and carbohydrate and 9 kcal per gram of fat.`)
};

const es_macro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte un objetivo calórico diario en gramos de proteína, carbohidratos y grasa. Elige un reparto y la calculadora hace los cálculos usando 4 kcal por gramo de proteína y carbohidrato, y 9 kcal por gramo de grasa.`)
};

const de_macro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wandle ein tägliches Kalorienziel in Gramm Protein, Kohlenhydrate und Fett um. Wähle eine Verteilung, und der Rechner übernimmt die Berechnung mit 4 kcal pro Gramm Protein und Kohlenhydrate sowie 9 kcal pro Gramm Fett.`)
};

const nl_macro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet een dagelijks caloriedoel om in grammen eiwit, koolhydraten en vet. Kies een verdeling en de calculator rekent het uit met 4 kcal per gram eiwit en koolhydraten en 9 kcal per gram vet.`)
};

const fr_macro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez un objectif calorique quotidien en grammes de protéines, glucides et lipides. Choisissez une répartition et le calculateur fait le calcul avec 4 kcal par gramme de protéines et glucides et 9 kcal par gramme de lipides.`)
};

const it_macro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma un obiettivo calorico giornaliero in grammi di proteine, carboidrati e grassi. Scegli una ripartizione e il calcolatore fa i conti usando 4 kcal per grammo di proteine e carboidrati e 9 kcal per grammo di grassi.`)
};

const pt_br2_macro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme uma meta calórica diária em gramas de proteína, carboidrato e gordura. Escolha uma divisão e a calculadora faz as contas usando 4 kcal por grama de proteína e carboidrato e 9 kcal por grama de gordura.`)
};

const pt_macro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme um objetivo calórico diário em gramas de proteína, hidratos e gordura. Escolha uma divisão e a calculadora faz as contas usando 4 kcal por grama de proteína e hidratos de carbono e 9 kcal por grama de gordura.`)
};

const ja_macro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1日のカロリー目標をタンパク質・炭水化物・脂質のグラム数に変換します。配分を選ぶと、タンパク質と炭水化物は1gあたり4kcal、脂質は1gあたり9kcalとして自動計算されます。`)
};

const zh_macro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将每日热量目标转换为蛋白质、碳水和脂肪的克数。选择一种配比，计算器会按每克蛋白质和碳水化合物 4 千卡、每克脂肪 9 千卡进行计算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_intro", locale)
	if (locale === "en") return en_macro_intro(inputs)
	if (locale === "es") return es_macro_intro(inputs)
	if (locale === "de") return de_macro_intro(inputs)
	if (locale === "nl") return nl_macro_intro(inputs)
	if (locale === "fr") return fr_macro_intro(inputs)
	if (locale === "it") return it_macro_intro(inputs)
	if (locale === "pt-BR") return pt_br2_macro_intro(inputs)
	if (locale === "pt") return pt_macro_intro(inputs)
	if (locale === "ja") return ja_macro_intro(inputs)
	return zh_macro_intro(inputs)
};